import { Bot, Brain, Cpu, Gauge, Layers, Network, Server } from 'lucide-react';

export const courses = [
  {
    title: 'Embedded & IoT Foundations',
    description: 'Master firmware, sensors, protocols, security, power, and OTA.',
    color: '#FF6F61',
    icon: Cpu,
    course_id: 37,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/embedded__iot_foundations-37/index.html',
  },
  {
    title: 'Edge AI Fundamentals',
    description: 'Train, quantize, and deploy portable, power-efficient edge models.',
    color: '#8B5CF6',
    icon: Brain,
    course_id: 36,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/edge_ai_fundamentals-36/index.html',
  },
  {
    title: 'Embedded Linux for Edge Systems',
    description: 'Compose, containerize, and secure embedded Linux edge systems.',
    color: '#A855F7',
    icon: Server,
    course_id: 42,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/embedded_linux_for_edge_systems-42/index.html',
  },
  {
    title: 'Edge Networking, Streaming & Ops',
    description: 'Orchestrate resilient edge networking, streaming, observability, and operations.',
    color: '#C084FC',
    icon: Network,
    course_id: 40,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/edge_networking_streaming__ops-40/index.html',
  },
  {
    title: 'Edge Robotics & Perception',
    description: 'Build real-time perception, sensor fusion, planning, autonomous navigation.',
    color: '#00BFFF',
    icon: Bot,
    course_id: 38,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/edge_robotics__perception-38/index.html',
  },
  {
    title: 'Edge AI Platforms & Accelerators',
    description: 'Benchmark, optimize, and deploy across heterogeneous edge accelerators.',
    color: '#FF6F61',
    icon: Gauge,
    course_id: 39,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/edge_ai_platforms__accelerators-39/index.html',
  },
  {
    title: 'SoC Design for Edge AI & IoT',
    description: 'Design heterogeneous SoCs balancing performance, power, area for edge intelligence.',
    color: '#FFD93D',
    icon: Layers,
    course_id: 41,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/soc_design_for_edge_ai__iot-41/index.html',
  },
  {
    title: 'Agentic AI — Building Autonomous AI Systems',
    description: 'Learn to build autonomous, goal-driven AI agents using modern frameworks.',
    color: '#FF0F61',
    icon: Bot,
    course_id: 43,
    url: 'https://storage.googleapis.com/interactivebooks-dev/website/agentic_ai__building_autonomous_and_goal-driven_ai_systems-43/index.html',
  },
];

export type Course = (typeof courses)[number];

export function findCourseById(courseId: number) {
  return courses.find((course) => course.course_id === courseId) ?? null;
}
